import { objectSpread2 as _objectSpread2, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers';
import { DateTime } from 'luxon';
import { DateRangeBoundary } from '../constants.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _excluded = ["isStart", "isEnd", "withinRange", "withinPreview", "onMouseEnter", "onMouseLeave", "className"],
    _excluded2 = ["day", "previewValue", "onPreviewChange", "rangeBoundary", "rangeStart", "rangeEnd", "rangeColor"];
var componentRoot = createComponentSlot({
  name: "CinRangePickersDay",
  slot: "Root"
});

var RangePickersDayBase = function RangePickersDayBase(_ref) {
  var isStart = _ref.isStart,
      isEnd = _ref.isEnd,
      withinRange = _ref.withinRange,
      withinPreview = _ref.withinPreview,
      onMouseEnter = _ref.onMouseEnter,
      onMouseLeave = _ref.onMouseLeave,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave,
    className: classnames(componentRoot.className, className, {
      start: isStart,
      end: isEnd,
      range: withinRange,
      preview: withinPreview
    })
  }, /*#__PURE__*/React.createElement(PickersDay, props));
};

RangePickersDayBase.propTypes = {
  isStart: propTypes.bool,
  isEnd: propTypes.bool,
  withinRange: propTypes.bool,
  withinPreview: propTypes.bool,
  onMouseEnter: propTypes.func,
  onMouseLeave: propTypes.func,
  color: propTypes.any
};
var RangePickersDayRoot = styled(RangePickersDayBase, _objectSpread2(_objectSpread2({}, componentRoot.styledOptions), {}, {
  skipSx: true,
  skipVariantsResolver: true
}))(function (_ref2) {
  var theme = _ref2.theme,
      isStart = _ref2.isStart,
      isEnd = _ref2.isEnd,
      withinRange = _ref2.withinRange,
      withinPreview = _ref2.withinPreview,
      _ref2$color = _ref2.color,
      color = _ref2$color === void 0 ? "primary" : _ref2$color;
  return {
    "> .MuiPickersDay-root": _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
      transition: "none !important"
    }, (withinPreview || withinRange) && {
      borderRadius: 0,
      border: "none !important",
      color: theme.palette[color].contrastText,
      marginLeft: isStart ? 2 : 0,
      marginRight: isEnd ? 2 : 0,
      width: 40 - (isStart ? 2 : 0) - (isEnd ? 2 : 0),
      paddingRight: isStart && !isEnd ? 2 : 0,
      paddingLeft: !isStart && isEnd ? 2 : 0
    }), withinPreview && {
      backgroundColor: theme.palette[color].light,
      "&:hover, &:focus": {
        backgroundColor: theme.palette[color].main
      }
    }), withinRange && {
      backgroundColor: theme.palette[color].main,
      "&:hover, &:focus": {
        backgroundColor: theme.palette[color].dark
      }
    }), isStart && {
      borderTopLeftRadius: "50%",
      borderBottomLeftRadius: "50%"
    }), isEnd && {
      borderTopRightRadius: "50%",
      borderBottomRightRadius: "50%"
    })
  };
});

var RangePickersDay = function RangePickersDay(_ref3) {
  var day = _ref3.day,
      previewValue = _ref3.previewValue,
      onPreviewChange = _ref3.onPreviewChange,
      rangeBoundary = _ref3.rangeBoundary,
      rangeStart = _ref3.rangeStart,
      rangeEnd = _ref3.rangeEnd,
      rangeColor = _ref3.rangeColor,
      pickersDayProps = _objectWithoutProperties(_ref3, _excluded2);

  var withinRange = false;
  var rangeFrom = rangeStart === null || rangeStart === void 0 ? void 0 : rangeStart.startOf("day");
  var rangeTo = rangeEnd === null || rangeEnd === void 0 ? void 0 : rangeEnd.startOf("day");
  var withinPreview = false;
  var previewFrom = undefined;
  var previewTo = undefined;

  if (rangeFrom && rangeTo) {
    withinRange = rangeFrom <= day && day <= rangeTo;
  } else {
    previewFrom = rangeFrom !== null && rangeFrom !== void 0 ? rangeFrom : rangeTo;
    previewTo = rangeTo !== null && rangeTo !== void 0 ? rangeTo : rangeFrom;
  }

  if (previewValue && rangeBoundary === DateRangeBoundary.End) {
    previewFrom = DateTime.min(previewValue, rangeFrom !== null && rangeFrom !== void 0 ? rangeFrom : previewValue);
    previewTo = previewValue;
  }

  if (previewValue && rangeBoundary === DateRangeBoundary.Start) {
    previewFrom = previewValue;
    previewTo = DateTime.max(previewValue, rangeTo !== null && rangeTo !== void 0 ? rangeTo : previewValue);
  }

  if (previewFrom && previewTo) {
    withinPreview = previewFrom <= day && day <= previewTo;
    withinRange = withinRange && withinPreview;
  }

  var startOfWeek = day.startOf("week");
  var endOfWeek = day.endOf("week").startOf("day");
  var startOfMonth = day.startOf("month");
  var endOfMonth = day.endOf("month").startOf("day");
  var hasSelection = !!rangeFrom || !!rangeTo;
  var startOfSelection = previewFrom ? +day === +previewFrom : rangeFrom && +day === +rangeFrom;
  var endOfSelection = previewTo ? +day === +previewTo : rangeTo && +day === +rangeTo;
  return /*#__PURE__*/React.createElement(RangePickersDayRoot, _extends({}, pickersDayProps, {
    day: day,
    color: rangeColor,
    selected: hasSelection && (startOfSelection || endOfSelection),
    isStart: startOfSelection || (withinRange || withinPreview) && +day === +startOfWeek || (withinRange || withinPreview) && +day === +startOfMonth,
    isEnd: endOfSelection || (withinRange || withinPreview) && +day === +endOfWeek || (withinRange || withinPreview) && +day === +endOfMonth,
    withinRange: hasSelection && withinRange,
    withinPreview: hasSelection && withinPreview,
    onMouseEnter: function onMouseEnter() {
      return onPreviewChange(day);
    },
    onMouseLeave: function onMouseLeave() {
      return onPreviewChange(null);
    }
  }));
};

RangePickersDay.propTypes = {
  previewValue: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])]),
  onPreviewChange: propTypes.func.isRequired,
  rangeBoundary: propTypes.any,
  rangeStart: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])]),
  rangeEnd: propTypes.oneOfType([propTypes.any, propTypes.oneOf([null])]),
  rangeColor: propTypes.any
};
var RangePickersDay$1 = RangePickersDay;

export { RangePickersDay$1 as default };
